export const OPEN_RATING = "OPEN_RATING";
export const CLOSE_RATING = "CLOSE_RATING";

export const OPEN_RATING_MUTATION = "OPEN_RATING_MUTATION";

export default {
    namespace: "rateModule",

    state: () => ({
        isOpen: false,
    }),

    actions: {
        [OPEN_RATING](context) {
            context.commit(OPEN_RATING_MUTATION, true);
        },

        [CLOSE_RATING](context) {
            context.commit(OPEN_RATING_MUTATION, false)
        }
    },

    mutations: {
        [OPEN_RATING_MUTATION](state, payload = false) {
            state.isOpen = payload;
        }
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/ratingModule.js